import "bootstrap/dist/css/bootstrap.min.css";
import LoginForm from "./LoginForm";

const API_BASE_URL = process.env.REACT_APP_API_URL; // Load API URL


export default function HomePage({ setToken, token }) {
  return (
    <div className="container mt-4 text-center">
      <h1 className="mb-4 display-4">Welkom bij CRM Advocaten</h1>
      <p className="lead">Beheer uw contacten en documenten eenvoudig en veilig.</p>
      
      {!token ? (
        <div className="mt-4">
          <h3>Log in om door te gaan</h3>
          <LoginForm setToken={setToken} API_BASE_URL={API_BASE_URL} />
        </div>
      ) : (
        <div className="mt-4">
          <p className="text-success">U bent ingelogd! Gebruik de navigatie om verder te gaan.</p>
        </div>
      )}
    </div>
  );
}
